import { render, staticRenderFns } from "./text-summary-1p1c.vue?vue&type=template&id=394ba112&scoped=true&"
import script from "./text-summary-1p1c.vue?vue&type=script&lang=js&"
export * from "./text-summary-1p1c.vue?vue&type=script&lang=js&"
import style0 from "./text-summary-1p1c.vue?vue&type=style&index=0&id=394ba112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394ba112",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VImg,VLayout,VTooltip})
